import { GET_BLOG_TYPES } from '../actions/types';

const blogTypes = (state = {}, action) => {
  switch (action.type) {
    case GET_BLOG_TYPES:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default blogTypes;